module.exports = __webpack_public_path__ + "media/payments/select-domain-75c05090.png";